export const DEREK_EMAIL = "derek@onepage.guide"
export const WAIT_FOR_DOM_TO_PAINT_MS = 250

// https://bulma.io/documentation/columns/sizes/
export const VALID_COLUMN_WIDTHS = ["is-2", "is-3"]

export const H2_STYLE_CLASSES = ["is-size-6", "has-text-weight-semibold"]
